// removed by extract-text-webpack-plugin
module.exports = {"pager":"pager__1y_i2","parsed":"parsed__N3jDJ","value":"value__1MYG1","key":"key__1-Apk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/DeviceDetail/coms/DeviceLogs/styles.scss
// module id = 2237
// module chunks = 1